var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1055 23.3028C45.1055 35.3444 35.3444 45.1055 23.3028 45.1055C11.2611 45.1055 1.5 35.3444 1.5 23.3028C1.5 11.2611 11.2611 1.5 23.3028 1.5C35.3444 1.5 45.1055 11.2611 45.1055 23.3028Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3028 37.4746C27.0614 37.4746 30.6661 35.9815 33.3238 33.3237C35.9815 30.666 37.4746 27.0613 37.4746 23.3028C37.4746 19.5442 35.9815 15.9395 33.3238 13.2818C30.6661 10.624 27.0614 9.13095 23.3028 9.13095M23.3028 37.4746C19.5442 37.4746 15.9396 35.9815 13.2819 33.3237C10.6241 30.666 9.13104 27.0613 9.13104 23.3028C9.13104 19.5442 10.6241 15.9395 13.2819 13.2818C15.9396 10.624 19.5442 9.13095 23.3028 9.13095M23.3028 37.4746V26.5732M23.3028 9.13095V20.0323M35.5778 16.2169L26.1372 21.6675M20.4707 24.938L11.0301 30.3887M35.5778 30.3887L26.1372 24.938M20.4707 21.6675L11.0301 16.2169",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5732 23.3027C26.5732 24.1701 26.2287 25.002 25.6154 25.6153C25.002 26.2286 24.1702 26.5732 23.3028 26.5732C22.4355 26.5732 21.6036 26.2286 20.9903 25.6153C20.377 25.002 20.0324 24.1701 20.0324 23.3027C20.0324 22.4354 20.377 21.6035 20.9903 20.9902C21.6036 20.3769 22.4355 20.0323 23.3028 20.0323C24.1702 20.0323 25.002 20.3769 25.6154 20.9902C26.2287 21.6035 26.5732 22.4354 26.5732 23.3027Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThree);
export default __webpack_public_path__ + "static/media/icon-three.2d33b379c4fae45974a7b698aa8e81a1.svg";
export { ForwardRef as ReactComponent };